import { useEffect, useState, useCallback } from 'react'
import FirmViewQuote from 'src/components/portal/default/FirmViewComponents/FirmViewQuote'
import { useAuth } from 'src/context/auth'
import { api } from 'src/services/apiClient'
import { FirmDetailsQuoteData } from 'src/dtos/portal'

const Quote = () => {
  const { user } = useAuth()
  const [firmQuote, setFirmQuote] = useState<FirmDetailsQuoteData | undefined>(undefined)

  const fetchQuoteDetails = useCallback(async () => {
    if(user?.firmId) {
      try {
        const { data } = await api.get(`/Firm/GetQuoteDetails/${user.firmId}`)

        setFirmQuote(data)
      } catch(e) {
        setFirmQuote(undefined)
      }
    } else {
      setFirmQuote(undefined)
    }
  }, [user.firmId])

  useEffect(() => {
    fetchQuoteDetails()
  }, [fetchQuoteDetails])
  
  return (
    <div>
      <FirmViewQuote 
        firmDetailsQuote={firmQuote}
        firmId={user.firmId}
      />
    </div>
  )
}

export default Quote